import { DatePicker as AntDatePicker, DatePickerProps } from 'antd'
import en from 'antd/es/date-picker/locale/en_US'

const DatePicker = (props: DatePickerProps) => {
  // Component level locale
  const locale: typeof en = {
    ...en,
    lang: {
      ...en.lang,
      fieldDateFormat: 'YYYY-MM-DD',
      fieldDateTimeFormat: 'YYYY-MM-DD HH:mm',
      yearFormat: 'YYYY',
      cellYearFormat: 'YYYY',
    },
  }

  return (
    <AntDatePicker
      {...props}
      showTime={
        typeof props.showTime === 'object'
          ? props.showTime
          : props.showTime === false
            ? false
            : true
      }
      locale={locale}
    />
  )
}

export default DatePicker
